import { useEffect } from 'react';
import { useSelector } from 'react-redux';

function TitleListener() {
  const pageTitle = useSelector((state) => state.title.pageTitle);

  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} - Fairtree Portal`;
    }
  }, [pageTitle]);

  return null;
}

export default TitleListener;
